import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledCheckbox, StyledLabel } from './Checkbox.components';
import { IDash, ITick } from '../Iconography';
/**
 * Simple checkbox.
 */
export const Checkbox = ({ checked = false, disabled = false, dataId, enableTab = true, hideLabel = false, label, indeterminate = false, onChecked = () => null, style, }) => {
    /**
     * Handler called when the checkbox is clicked.
     * @param e The mouse event.
     */
    const handleOnClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (indeterminate)
            onChecked(!indeterminate);
        else
            onChecked(!checked);
    };
    /**
     * Handler called a key is pressed on the checkbox.
     * @param e The mouse event.
     */
    const handleOnKeyDown = (e) => {
        if (e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            if (indeterminate)
                onChecked(!indeterminate);
            else
                onChecked(!checked);
        }
    };
    /**
     * Renders the checkbox component.
     * @param includeStyle True to apply external styles.
     * @param labelledBy The id of the label component.
     * @returns The checkbox JSX.
     */
    const renderCheckbox = (includeStyle = true, labelledBy) => (_jsx(StyledCheckbox, Object.assign({ "aria-checked": indeterminate ? 'mixed' : checked, "aria-disabled": disabled, "aria-label": label, "aria-labelledby": labelledBy, "data-id": dataId, onClick: !disabled ? handleOnClick : undefined, onKeyDown: !disabled ? handleOnKeyDown : undefined, role: "checkbox", tabIndex: enableTab && !disabled ? 0 : -1, sx: Object.assign({ marginRight: hideLabel ? 0 : '0.5rem' }, (includeStyle ? style : undefined)) }, { children: indeterminate ? _jsx(IDash, { size: 16 }) : _jsx(_Fragment, { children: checked ? _jsx(ITick, { size: 16 }) : null }) })));
    // If there is a label then display the FormControlLabel component.
    if (label) {
        return (_jsxs(StyledLabel, Object.assign({ "data-id": `${dataId}-label`, id: `${dataId}-label`, onClick: !disabled ? handleOnClick : undefined, sx: style }, { children: [renderCheckbox(false, `${dataId}-label`), !hideLabel && label] })));
    }
    // Display just the Checkbox.
    return renderCheckbox();
};
export default Checkbox;
